<template>
  <div class="project item">
    <div class="container custom">
      <div class="project__content list">
        <div class="project__content-breadcrumb" data-aos="fade">
          <el-breadcrumb separator="/">
            <template v-for="(item, index) in routeList">
              <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="{ name: item.name }">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div class="list__box">
          <div class="list__box-item" data-aos="fade-up">
            <div class="project__content-title">Portal API Services</div>
            <div class="project__content-subtitle">The portal to access to top-notch technologies and solutions</div>
            <div class="project__content-text">
              Leading in applying Blockchain & AI on software products on the Vietnamese market, TimeBird is eager to share useful API services to help other development teams shortening software development duration.
              <br>
              Portal API Services was built with 2 initially products, Electronic Know Your Customer (eKYC) and Blockchain Service.
            </div>
          </div>
          <div class="list__box-item" data-aos="fade" data-aos-delay="500">
            <div class="project__content-image">
              <img class="mw50" src="/assets/images/project/api-image.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="project__tab" data-aos="fade" data-aos-delay="500">
        <div class="project__tab-item" @click="showTab" :class="{ active: isTab }">
          <div class="item__content">
            <div class="item__content-subtitle">Our Services</div>
            <div class="item__content-title">eKYC <br> Service</div>
            <div class="item__content-text">
              eKYC Service provides API to help verify online user through identity document such as ID card and passport.
              <br>
              Using TimeBird’s eKYC will help other development team identify users quickly and accurately. It’s also the inevitable trend of high technology.
            </div>
            <div class="item__content-button" v-if="!isTab">See more</div>
          </div>
          <div class="item__image">
            <img src="/assets/images/project/api-01.png" alt="image">
          </div>
        </div>
        <div class="project__tab-item" @click="showTab" :class="{ active: !isTab }">
          <div class="item__content">
            <div class="item__content-subtitle">Our Services</div>
            <div class="item__content-title">Blockchain <br> Service</div>
            <div class="item__content-text">
              Blockchain Service is to call API to create an address, withdraw, get transactions on Blockchain platforms such as exchanges, e-wallets. To build a new chain or do a Blockchain application research requires great effort and cost.
              <br>
              Using Blockchain Service API reduce the development time for a new fintech products quickly with more reasonable cost.
            </div>
            <div class="item__content-button" v-if="isTab">See more</div>
          </div>
          <div class="item__image">
            <img src="/assets/images/project/api-02.png" alt="image">
          </div>
        </div>
      </div>
    </div>
    <div class="project__feature">
      <div class="container custom">
        <div class="project__feature-title" data-aos="fade-up">5 Why to choose TimeBird</div>
        <div class="project__feature-box">
          <div class="box__content">
            <template v-for="(item, index) in listFeature">
              <div class="box__content-list" data-aos="fade-right" :key="index">
                <div class="list__title" v-if="item.title">
                  <div class="icon">
                    <img src="/assets/images/layouts/icon-star.png" alt="icon">
                  </div>
                  {{ item.title }}
                </div>
                <template v-for="(_item, index) in item.listFeatureItem">
                  <div class="list__item" :key="index">
                    <div class="icon">
                      <img src="/assets/images/layouts/icon-bookmark.png" alt="icon">
                    </div>
                    {{ _item.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="box__image" data-aos="fade-left">
            <img src="/assets/images/project/feature-image.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="project__guide">
      <div class="container custom">
        <div class="project__guide-title" data-aos="fade-up">How to get API on portal</div>
        <div class="project__guide-step" data-aos="fade" data-aos-delay="500">
          <el-steps :active="active">
            <el-step></el-step>
            <el-step></el-step>
            <el-step></el-step>
          </el-steps>
          <div class="step__progress big">
            <div class="step__progress-item register" :class="{ active: active === 0 }">
              <img src="/assets/images/project/icon-register.svg" alt="icon">
            </div>
            <div class="step__progress-item checkbox" :class="{ active: active === 1 }">
              <img src="/assets/images/project/icon-checkbox.svg" alt="icon">
            </div>
            <div class="step__progress-item payment" :class="{ active: active === 2 }">
              <img src="/assets/images/project/icon-payment.svg" alt="icon">
            </div>
            <div class="step__progress-item key" :class="{ active: active === 3 }">
              <img src="/assets/images/project/icon-key.svg" alt="icon">
            </div>
          </div>
          <template v-if="active === 0">
            <div class="step__item">
              <div class="step__item-title">Step 1</div>
              <div class="step__item-content">Register on <a href="https://api.timebird.technology/" target="_blank" class="link">https://api.timebird.technology/</a></div>
            </div>
          </template>
          <template v-if="active === 1">
            <div class="step__item">
              <div class="step__item-title">Step 2</div>
              <div class="step__item-content">Create a project and select the API service as needed</div>
            </div>
          </template>
          <template v-if="active === 2">
            <div class="step__item">
              <div class="step__item-title">Step 3</div>
              <div class="step__item-content"> Select proper payment channel</div>
            </div>
          </template>
          <template v-if="active === 3">
            <div class="step__item">
              <div class="step__item-title">Step 4</div>
              <div class="step__item-content">Use the API keys shown on the screen for your purposes</div>
            </div>
          </template>
        </div>
        <div class="project__guide-button" data-aos="fade">
          <el-button @click="prev" class="button__prev" :class="{ active: active > 0 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
          <el-button @click="next" class="button__next" :class="{ active: active < 3 }">
            <img src="/assets/images/project/icon-chevron.svg" alt="icon">
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      isTab: true,
      listFeature: [
        { title: '', listFeatureItem: [
          { title: 'Provide APIs with the latest trending technology and reasonable cost' },
          { title: 'Integrate easy' },
          { title: 'Good support for components of HTML, MVC, RESTful' },
          { title: 'Well optimize for various limited-bandwidth devices such as smartphones, PCs, tablets' },
          { title: 'Offer 247 support services' },
        ]},
      ]
    }
  },
  computed: {
    routeList () {
      return this.$route.matched
    }
  },
  methods: {
    next() {
      if (this.active++ > 2) this.active = 3;
    },
    prev() {
      if (this.active-- < 1) this.active = 0;
    },
    showTab() {
      this.isTab = !this.isTab
    }
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>